import { createIcon } from '@frontend/components';

const RatingIcon = createIcon({
  displayName: 'RatingIcon',
  viewBox: '0 0 75 75',
  path: (
    <path
      d="
M 40.000 55.000
L 63.511 72.361
L 54.266 44.635
L 78.042 27.639
L 48.817 27.865
L 40.000 0.000
L 31.183 27.865
L 1.958 27.639
L 25.734 44.635
L 16.489 72.361
L 40.000 55.000
"
    />
  ),
});

export default RatingIcon;
